<script setup lang="ts">
interface Props {
  mobile?: boolean
}
withDefaults(defineProps<Props>(), { mobile: false })
</script>
<template>
  <div
    class="q-pl-sm row items-center no-wrap"
    :class="{
      'q-gutter-xs': mobile,
      'q-gutter-sm': !mobile,
    }"
  >
    <slot />
  </div>
</template>
